import {
  BusinessLevelMarketingInfo, DynamicPricingSettings, EventProfile,
  LegacyPaymentSettings, LocalizedRichDescription, PoliciesSettings, TicketSupplementTemplate,
} from 'in-time-core';

import { Injectable } from '@angular/core';
import { DonationSettings } from './models/donation-settings';

export type EventCacheEntry = {
  event: EventProfile;
  dynamicPricingSettings: DynamicPricingSettings | null;
  legacyProductPaymentSettings: LegacyPaymentSettings | null;
  productsDescription: LocalizedRichDescription | null;
  marketingInfo: BusinessLevelMarketingInfo;
  policiesSettings: PoliciesSettings | null;
  donationSettings: DonationSettings | null;
  ticketSupplements: TicketSupplementTemplate[];
  isPhoneNumberMandatoryForGuests: boolean,
};

@Injectable({ providedIn: 'root' })
export class EventCacheService {
  private readonly cache: EventCacheEntry[] = [];

  isCachedByUniqueId(eventId: string): boolean {
    for(let i = 0; i < this.cache.length; i++) {
      if(this.cache[i].event.uniqueId == eventId) {
        return true;
      }
    }

    return false;
  }

  isCachedByWebRoute(webRoute: string): boolean {
    for(let i = 0; i < this.cache.length; i++) {
      if(this.cache[i].event.webRoute == webRoute) {
        return true;
      }
    }

    return false;
  }

  set({
    event,
    dynamicPricingSettings,
    legacyProductPaymentSettings,
    productsDescription,
    marketingInfo,
    policiesSettings,
    donationSettings,
    ticketSupplements,
    isPhoneNumberMandatoryForGuests,
  }:{
    event: EventProfile,
    dynamicPricingSettings: DynamicPricingSettings | null,
    legacyProductPaymentSettings: LegacyPaymentSettings | null,
    productsDescription: LocalizedRichDescription | null,
    marketingInfo: BusinessLevelMarketingInfo,
    policiesSettings: PoliciesSettings | null,
    donationSettings: DonationSettings | null,
    ticketSupplements: TicketSupplementTemplate[],
    isPhoneNumberMandatoryForGuests: boolean,
  }
  ): void {
    this.cache.push({
      event,
      dynamicPricingSettings: dynamicPricingSettings ?? null,
      legacyProductPaymentSettings: legacyProductPaymentSettings ?? null,
      productsDescription: productsDescription ?? null,
      marketingInfo,
      policiesSettings,
      donationSettings,
      ticketSupplements,
      isPhoneNumberMandatoryForGuests,
    });
  }

  tryGetByUniqueId(eventId: string): EventCacheEntry | null {
    for(let i = 0; i < this.cache.length; i++) {
      if(this.cache[i].event.uniqueId == eventId) {
        return this.cache[i];
      }
    }

    return null;
  }

  tryGetByWebRoute(webRoute: string): EventCacheEntry | null {
    for(let i = 0; i < this.cache.length; i++) {
      if(this.cache[i].event.webRoute == webRoute) {
        return this.cache[i];
      }
    }

    return null;
  }
}
